import React from "react"

const IconSparcaComplete = (props) => {
    const { width, height, fill, className, style } = props
    return (
        <svg
            id="icon-sparca-complete"
            className={className}
            viewBox="0 0 32 32"
            width={width}
            height={height}
            fill={fill}
            style={style}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path d="M30.39,4a.85.85,0,0,0-1.19.12L10.84,26.5,2.9,18.17a.83.83,0,0,0-.59-.26.88.88,0,0,0-.61.23.85.85,0,0,0-.26.6.84.84,0,0,0,.23.6l8.6,9a.84.84,0,0,0,.61.27h0a.85.85,0,0,0,.63-.31l19-23.13A.85.85,0,0,0,30.39,4ZM10.88,28.43Z" />
        </svg>
    )
}

export default IconSparcaComplete
